<template>
  <q-layout view="lHh lpr fFf">
    <q-header elevated class="bg-purple-5" v-if="!checkLogin">
      <q-toolbar>
        <q-btn
          flat
          dense
          round
          @click="leftDrawerOpen = !leftDrawerOpen"
          aria-label="Menu"
          icon="menu"
        />

        <q-toolbar-title>
          Pasar Digital Marina Market Place
        </q-toolbar-title>
      </q-toolbar>
    </q-header>

    <q-drawer v-model="leftDrawerOpen" show-if-above bordered class="bg-grey-2" v-if="!checkLogin">
      <SideBar/>
    </q-drawer>

    <q-page-container>
      <router-view />
    </q-page-container>

    <!-- <q-footer elevated class="bg-grey-8 text-white">
      <q-toolbar>
        <q-toolbar-title>
          <q-avatar>
            <img src="https://cdn.quasar.dev/logo-v2/svg/logo-mono-white.svg">
          </q-avatar>
          <div>Title</div>
        </q-toolbar-title>
      </q-toolbar>
    </q-footer> -->
    
  </q-layout>
</template>

<script>
import { ref } from 'vue'
import SideBar from './components/SideBar.vue';

export default {
  name: 'LayoutDefault',

  components: {
    SideBar
  },

  data () {
    return {
      leftDrawerOpen: ref(false)
    }
  },

  computed: {
      checkLogin() {
          if (this.$route.name === 'Login' || this.$route.name === 'Registrasi') {
              return true;
          } else {
              return false;
          }
      }
  },

}
</script>
